
<v-content>
  <v-row wrap class="layout">
    <v-col cols="12">
      <h1 class="display-1">
        {{ $t("IMPRINT_HEADER") }}
      </h1>
    </v-col>
    <v-col cols="12" class="imprintContent">
      <div v-html="$t('IMPRINT_TEXT')"></div>
    </v-col>
  </v-row>
</v-content>

